import { connect } from "react-redux";

import { fetchRequests, UPDATE_REQUESTS_ACTIVE_TAB, ADD_FILTER } from "common/actions/requests";

import { TabbedPivotTable } from "../common/tabbedPivotTable";
import { pivots } from "./pivots";

const fields = [{
    key: "requests_count",
    name: "requests_count",
    valueType: "number"
}, {
    key: "average_request_time",
    name: "average_request_time",
    valueType: "number",
    weighted: true
}, {
    key: "pages_count",
    name: "pages_count",
    valueType: "number"
}];

const fieldMap = {
    ...pivots,
    average_request_time: "Average request duration (in ms)",
    requests_count: "Total requests",
    pages_count: "Total pages"
};

const mapStateToProps = (state, ownProps) => ({
    section: state.requests.section,
    queryDeps: {
        date_range: state.common.date_range,
        qualifiers: state.requests.qualifiers
    }
});

const mapDispatchToProps = {
    ADD_FILTER,
    UPDATE_SECTION: UPDATE_REQUESTS_ACTIVE_TAB
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(TabbedPivotTable);

export function RequestPivotTableRedux(props) {
    return (
        <Connected
            initialStructure={{
                columns: [],
                values: [{
                    name: "requests_count",
                    operation: ["sum"]
                }, {
                    name: "average_request_time",
                    operation: ["sum"]
                }, {
                    name: "pages_count",
                    operation: ["sum"]
                }],
                filters: []
            }}
            initialSection="merchant_ref"
            initialTabs={[
                "merchant_ref",
                "uri_template",
                "username",
                "product",
                "api_version"
            ].map((pivot) => ({
                id: pivot,
                label: pivots[pivot],
                pivots: [pivot]
            }))}
            initialSorting={{
                field: "requests_count",
                dir: "desc"
            }}
            fields={fields}
            fieldMap={fieldMap}
            exportName="Requests"
            pivots={pivots}
            queryKey="requests"
            queryFn={fetchRequests}
            {...props}
        />
    );
}
